<template>
  <Modal title="加减补课次数" v-model="visible">
    <Form ref="classHourForm" class="form" :label-width="100"
          :model="classHourParam" :rules="classHourRule" >
      <Row>
        <Col :span="22">
        <Form-item label="加减补课次数" prop="num">
          <Input v-model.number="classHourParam.num"></Input>
        </Form-item>
        </Col>
        <Col :span="22">
        <Form-item label="原因" prop="reason">
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                 placeholder="长度不要超过100个字符"
                 v-model="classHourParam.reason" ></Input>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingUpdate" @click="update">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'UserLeaveNumModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      uid: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingUpdate: false,
        classHourParam: {
          num: '',
          reason: '',
        },
        classHourRule: {
          num: [
            { type: 'integer', required: true, message: '请输入数量', trigger: 'blur' },
            { validator (rule, value, callback, source, options) {
              let errors = []
              if (value === 0) {
                errors.push('数量不能为0')
                callback(errors)
                return
              }
              callback(errors)
            } },
            { type: 'integer', min: -100, max: 100, message: '请输入 -100 到 100 之间的整数', trigger: 'blur' }
          ],
          reason: [
            { required: true, message: '请输入原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      update () {
        let self = this
        self.loadingUpdate = true
        self.$refs.classHourForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingUpdate = false
            return
          }
          self.classHourParam.uid = self.uid
          self.$http.post('/bookCourseChange/addLesson', self.classHourParam).then(function (res) {
            self.loadingUpdate = false
            if (res) {
              self.visible = false
              self.$Message.success('提交申请加减补课成功!')
              return
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        this.classHourParam = {
          num: '',
          reason: '',
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserLessonNumModal.vue?1693c5ac